import { PersonalizedAdsStatus } from '@afterpaytouch/portal-api/consumer/subscriptions/personalizedads/types'
import { SubscriptionStatus } from '@afterpaytouch/portal-api/consumer/subscriptions/marketing/types'
import { Country } from '@afterpay/types'

export const convertSubscriptionStatusToBoolean = (status: SubscriptionStatus): boolean => status === 'SUBSCRIBED'

// For personalized ads, the 'UNDECIDED' state is considered to be oped-in, as the feature is opt-in
// by default, and we want the user to be provided the opportunity to opt-out.
export const convertPersonalizedAdsStatusToBoolean = (country: Country | undefined, status: PersonalizedAdsStatus): boolean =>
  status === 'SUBSCRIBED' || (status === 'UNDECIDED' && country !== Country.NZ && country !== Country.GB)
